export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = 'Il campo %s non è stato selezionato';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = 'Il campo %s non può rimanere vuoto';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = 'Il campo %s è obbligatorio';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = 'Il campo %s non è stato completato correttamente';
                break;

            case 'opt-in':
                translation = 'Spuntare la casella per proseguire';
                break;

            default:
                translation = 'Questo campo non è stato completato correttamente';
                break;
        }

        return translation;
    }
}
